import React from "react";
import "./Pagination.css";

// Generates the array of page numbers and ellipsis for pagination
const renderPaginationButtons = (currentPage, totalPages, maxVisiblePages = 3) => {
  const pages = [];

  // Always show the first page
  pages.push(1);

  // Calculate start and end page numbers
  let startPage = Math.max(2, currentPage - 1);
  let endPage = Math.min(totalPages - 1, currentPage + 1);

  // Adjust range if near the start or end
  if (currentPage === 1) {
    endPage = Math.min(totalPages - 1, currentPage + 2);
  }
  if (currentPage === totalPages) {
    startPage = Math.max(2, totalPages - 2);
  }

  // Add ellipsis if needed before the range
  if (startPage > 2) {
    pages.push('...');
  }

  // Add middle page numbers
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  // Add ellipsis if needed after the range
  if (endPage < totalPages - 1) {
    pages.push('...');
  }

  // Always show the last page if more than one page
  if (totalPages > 1) {
    pages.push(totalPages);
  }

  return pages;
};

const Pagination = ({
  currentPage,
  totalPages,
  onPageChange,
  className = "",
}) => {
  return (
    <div className={`containerPaginationPanel ${className}`}>
      <button
        onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
        disabled={currentPage === 1}
        className="pagination-button"
      >
        <span className="material-icons">chevron_left</span>
        Anterior
      </button>

      <div className="pagination-numbers">
        {renderPaginationButtons(currentPage, totalPages).map((p, index) =>
          p === '...' ? (
            <span key={`ellipsis-${index}`} className="pagination-ellipsis">...</span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className={`pagination-number${currentPage === p ? ' active' : ''}`}
            >
              {p}
            </button>
          )
        )}
      </div>

      <button
        onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
        disabled={currentPage === totalPages}
        className="pagination-button"
      >
        Próxima
        <span className="material-icons">chevron_right</span>
      </button>
    </div>
  );
};

export default Pagination;